import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20community%20creative%20workspace%20with%20wooden%20desk%20and%20various%20hobby%20items%20like%20camera%20yarn%20books%20and%20plants%2C%20soft%20natural%20warm%20lighting%2C%20friendly%20atmosphere%2C%20artistic%20lifestyle%20photography%20with%20gentle%20bokeh%20background&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="撸撸社社区氛围"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="font-heading text-4xl md:text-6xl text-white mb-4 tracking-wide">
          {siteConfig.tagline}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
          <Link
            to="/categories"
            className="px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-300 whitespace-nowrap"
          >
            探索兴趣分类
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-semibold text-white border border-white/40 hover:border-white hover:bg-white/10 rounded-md transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}